import { useState, useEffect, memo } from "react";
import { motion, AnimatePresence } from "framer-motion";

const lines = [
  "INITIALIZING TACTICAL INTERFACE...",
  "LOADING OPERATIVE DATABASE...",
  "ESTABLISHING SECURE CONNECTION...",
  "SCANNING STEAM TELEMETRY...",
  "READY.",
];

function Preloader({ onComplete }) {
  const [progress, setProgress] = useState(0);
  const [lineIndex, setLineIndex] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    let raf;
    let start = performance.now();
    const duration = 1800;
    const animate = (now) => {
      const elapsed = now - start;
      const p = Math.min((elapsed / duration) * 100, 100);
      setProgress(p);
      if (p < 100) raf = requestAnimationFrame(animate);
      else {
        setDone(true);
        setTimeout(() => onComplete(), 400);
      }
    };
    raf = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(raf);
  }, [onComplete]);

  useEffect(() => {
    if (lineIndex < lines.length - 1) {
      const t = setTimeout(() => setLineIndex((i) => i + 1), 300 + lineIndex * 150);
      return () => clearTimeout(t);
    }
  }, [lineIndex]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-[100] bg-[#09090b] flex flex-col items-center justify-center"
        >
          <div className="absolute inset-0 tactical-grid opacity-10" />

          <div className="mb-10">
            <div className="font-display font-black text-4xl md:text-6xl uppercase tracking-tight">
              <span style={{ WebkitTextStroke: "2px #F47B20", color: "transparent" }}>AEONEUH</span>
            </div>
          </div>

          <div className="w-72 md:w-80 space-y-1 mb-6">
            {lines.slice(0, lineIndex + 1).map((line, i) => (
              <div key={i} className="font-mono text-[9px] uppercase tracking-[0.2em]">
                <span className={i === lineIndex ? "text-[#F47B20]" : "text-white/20"}>
                  {"> "}{line}
                </span>
              </div>
            ))}
          </div>

          <div className="w-72 md:w-80">
            <div className="h-px bg-white/10 relative overflow-hidden">
              <div
                className="absolute inset-y-0 left-0 bg-[#F47B20] transition-none"
                style={{ width: `${Math.min(progress, 100)}%` }}
              />
            </div>
            <div className="flex justify-between mt-2 font-mono text-[8px] uppercase tracking-[0.2em] text-white/20">
              <span>{lineIndex >= lines.length - 1 ? "READY" : "LOADING"}</span>
              <span className="text-[#F47B20]">{Math.min(Math.round(progress), 100)}%</span>
            </div>
          </div>

          <div className="absolute top-5 left-5 font-mono text-[8px] text-white/10">SYS//v3</div>
          <div className="absolute bottom-5 right-5"><span className="w-1.5 h-1.5 rounded-full bg-[#F47B20] pulse-dot inline-block" /></div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default memo(Preloader);
